/**
 * A class around select tag options.
 *
 * @export
 * @class FormFieldSelectOption
 */
export class FormFieldSelectOption {
/**
 * Creates an instance of FormFieldValue.
 * @param {any} name The name of the option.
 * @param {any} [value=identifier] The value of the option wrapped. If none is supplied, the identifier is used.
 * @param {any} [image=undefined] A URL to an image, or a required() image.
 * @memberof FormFieldSelectOption
 */
  constructor (name, value, image = undefined) {
    this.version = 1
    this.identifier = this.identifierFromName(name)
    this.name = name
    this.value = value || this.identifier
    this.image = image
  }

  /**
   * Generates an identifier based on the user visible name.
   *
   * @param {any} name The name of the form.
   * @returns An identifier.
   * @memberof Form
   */
  identifierFromName (name) {
    return 'option.' + name.toLowerCase().replace(/\W/g, '')
  }
}
